import { useCallback, useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FormInput } from "../../components/FormInput";
import { F2020109Before } from "../../utility/service/personal-service";
import { checkDpSuccess } from "../../utility/service/tool-service";
import { addFormValidator } from "../../utility/validate/formValidator";
import { TreeSelect } from "primereact/treeselect";
import { Controller, useForm } from "react-hook-form";
import PrimeDialog from "../../components/dialog/PrimeDialog";

// 排除不符合資料流的節點key
const collectDescendantKeys = (nodes, targetKey) => {
  const keys = new Set();
  const findAndCollect = (list) => {
    for (const node of list) {
      if (node.key === targetKey) {
        const collectAll = (children) => {
          children?.forEach((child) => {
            keys.add(child.key);
            collectAll(child.children || []);
          });
        };
        collectAll(node.children || []);
        return true;
      }
      if (findAndCollect(node.children || [])) return true;
    }
    return false;
  };
  findAndCollect(nodes);
  return keys;
};

// 過濾不符合資料流的節點
const filterTree = (nodes, excludeKeys) =>
  nodes
    .filter((node) => !excludeKeys.has(node.key))
    .map((node) => ({
      ...node,
      children: node.children ? filterTree(node.children, excludeKeys) : null,
    }));

const UpdateRole = ({ register, errors, control, treeOptions, currentRoleKey, setValue, approveFlag }) => {
  const { t } = useTranslation();
  const [formRule, setFormRule] = useState([]); //表單驗證
  const [warning, setWarning] = useState(1);
  const [warningFlag, setWarningFlag] = useState(false);
  const filteredTreeOptions = useMemo(() => {
    if (!currentRoleKey || !treeOptions?.length) return treeOptions;
    const excludeKeys = collectDescendantKeys(treeOptions, currentRoleKey);
    excludeKeys.add(currentRoleKey);
    return filterTree(treeOptions, excludeKeys);
  }, [treeOptions, currentRoleKey]);

  //建立前查詢form 規則
  const axios_getCreateBefore = () => {
    F2020109Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule],
  );

  useEffect(() => {
    axios_getCreateBefore();
  }, []);

  return (
    <div className="grid">
      {approveFlag && (
        <div className="col-12">
          <label className="form-label">{t("parentNode")}</label>
          <Controller
            name="updateParentId"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <TreeSelect
                  showClear
                  value={field.value}
                  options={filteredTreeOptions}
                  onChange={(e) => {
                    field.onChange(e.value);
                    if (e.value === null || e.value === "" || e.value === undefined) {
                      setValue("updateParentId", "");
                    }
                    if (warning === 1) {
                      setWarning(2);
                      setWarningFlag(true);
                    }
                  }}
                  className={`w-full ${fieldState.invalid ? "p-invalid" : ""}`}
                  placeholder={t("plz_chs")}
                />
                {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
              </>
            )}
          />
        </div>
      )}

      <div className="col-12">
        <FormInput
          register={register}
          errors={errors}
          id="updateSymbol"
          type="text"
          labelText={t("role_symbol")}
          labelClass="control-label required"
          rules={setValidForm("symbol")}
        />
      </div>
      <div className="col-12">
        <FormInput
          register={register}
          errors={errors}
          id="updateName"
          type="text"
          labelText={t("role_name")}
          labelClass="control-label required"
          rules={setValidForm("name")}
        />
      </div>

      {/* 新增 Dialog */}
      <PrimeDialog
        visible={warningFlag}
        onClose={() => {
          setWarningFlag(false);
        }}
        onConfirm={() => {
          setWarningFlag(false);
        }}
        isShowCancelBtn={false}
        title={t("hint")}
        size="sm"
        bodyTemplate={t("modifyNodeHint")}
      />
    </div>
  );
};

export default UpdateRole;
